import { Http } from "../Http";
export class PasswordpolicyAPI {
  public static  getpasswordpolicy(input: any){
    var url = "api/passwordpolicybystatus/Active" ;
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }
  public static  getallpasswordpolicy(input: any){

    var url = "api/PasswordPolicy" ;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }
  public static savepasswordpolicy(input: any) {

    var obj=JSON.stringify(input);
    var url="api/savePasswordpolicy";
  
    const resultMethod = Http.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
   
        return res;
      }).catch((e: any) => {
     
        return e.response;
      });
    return resultMethod;
}
}
